import styled from "styled-components";
import { COLORS, responsive } from "../../../../styles/constants.style";

export const ProgramSearchResultWrapper = styled.div`
  margin: 19px 0px 39px;

  .form-header {
    display: flex;
    align-items: center;
    background-color: ${COLORS.primary_light_blue2};
    padding: 10px 16px;
    justify-content: space-between;

    ${responsive.MOBILE`
        padding: 10px 8px;
      `}
    .form-header-left {
      line-height: 20px;
      color: ${COLORS.cirrus_black10};
    }
  }
`;
